import {PhoneHQGlyph, PhoneHQCheckbox, PhoneHQButton} from 'ch3-ui-lib';

interface GoogleDescriptionProps {
    toggleCalendarAccess: Function;
    disabled?: any;

}

export const GoogleDescription = ({toggleCalendarAccess, disabled}: GoogleDescriptionProps) => {

    const google = {
        startTextTitle: "Integration with Google Workspace",
        startText: "Integrate PhoneHQ with your organization’s Google Workspace for seamless user management and calendar synchronization.",
        featuresTitle: "Integration Features:",
        features: [
            "Automatically add and deactivate users based on your organization’s Google Workspace directory.",
            "Import user details including first name, last name, and job title.",
            "Synchronize Google Calendar and automatically update your status in PhoneHQ based on your calendar events."],
        title: "Integration Steps:",
        description_1:
            'Click the “Integrate with Google Workspace” button below.',
        description_2:
            'You will be redirected to the Google Workspace Marketplace to install the PhoneHQ integration.',
        description_3:
            'Grant the necessary permissions to allow PhoneHQ to access your directory and calendar data.',
        description_4:
            'After installing the application in the Google Marketplace, please check the box below to proceed:',
        attentionDescription:
            "Proceed to the next step only if you have successfully completed the instructions above!",
        helpDescription:
            "If you encounter any issues during the process, please contact PhoneHQ Support or Google Workspace Support.",
        buttonLabel: "I've completed all the steps, proceed",
        instructionText: "You can also check detailed instruction in our ",
        syncWarning: 'Note: New Google Workspace users are automatically added to PhoneHQ after integration.'
    }
    return (
        <div className="flex flex-col mb-6 w-full ">
            <h2 className="text-2xl font-bold leading-none">{google.startTextTitle}</h2>
            <p className="text-base leading-6 w-full  my-4">{google.startText}</p>
            <h2 className="text-2xl font-bold leading-none">{google.featuresTitle}</h2>
            <ul className="list-disc pl-6 mb-8">
                {google.features.map((feature, index) => (
                    <li key={index} className="my-4 text-base font-medium leading-6">{feature}</li>
                ))}
            </ul>
            <h2 className="text-2xl font-bold leading-none l">{google.title}</h2>
            <ul className="list-decimal pl-6 mb-2">
                <li>
                    <p className="my-4 font-medium text-base leading-6  ">{google.description_1}</p>
                    <a href={window.__ENV__?.GOOGLE_WORKSPACE_MARKETPLACE_URL} target="_blank">
                    <PhoneHQButton size="sm" phq-id={`integration-GoogleWorkspace-startIntegrationBtn`}>Integrate with Google Workspace</PhoneHQButton></a>
                </li>
                <li>
                    <p className="my-4 text-base font-medium leading-6  ">{google.description_2}</p>
                </li>
                <li>
                    <p className="my-4 text-base font-medium leading-6 ">{google.description_3}</p>
                </li>
                <li>
                    <p className="my-4 text-base font-medium leading-6  ">{google.description_4}</p>
                </li>
            </ul>
            <div className="flex gap-3 mb-6 items-start">
                <div className="mt-1">
                    <PhoneHQCheckbox onCheckedChange={() => toggleCalendarAccess()} checked={disabled}/>
                </div>
                <div className="flex flex-col">

                    <div className="text-md font-medium mb-1">I have installed the application in Google Marketplace
                    </div>

                </div>
            </div>
            <div
                className="mb-4 text-sm p-4 border border-brand bg-brand-tint-subtle rounded">{google.attentionDescription}</div>
            <div className="mb-4">{google.helpDescription}</div>
            <div className="mb-4 flex items-center gap-2">{google.instructionText}
                <a className={'flex items-center '} target='_blank'
                   href={'https://support.phonehq.com/en/articles/53-google-workspace-integration-step-by-step'}><span
                    className='text-brand-ink underline'>Knowledge Base Article</span> <PhoneHQGlyph name='open_in_new' size={20}/> </a></div>
            <div
                className="mb-4 text-sm p-4 border border-brand bg-brand-tint-subtle rounded">{google.syncWarning}</div>
        </div>)
}
